import React, {Component} from 'react';
import CategoryItem from './component/CategoryItem';
import CategoryContent from './component/CategoryContent';
import PostContent from "./component/PostContent";
// import CatMenu from "./atoms/CatMenu";

import axios from 'axios';
import './App.css';

class App extends Component {

	constructor(props) {
		super(props);

		this.state = {
			hostUrl: this.props.dataUrl,
			categoryData: null,
			categoryItems: {
				data: null,
				catDesc: null
			},
			postData: null,
			categorieVypis: {
				data: [],
				rendered: false,
				disable: false
			}
		};
	}

	async _getOncePostFromTermByTermIdData(term) {

		let encodedURI = encodeURI(
			'http://'+ this.state.hostUrl +'/api/core/get_posts_by_catID/?post_type=references&taxonomy=references_category&term_id='+ term.term_id +'&posts_per_page=-1'
		);

		let catPosts = await axios.get(encodedURI,{'content-type': 'application/json; charset=utf-8'});

		if(!catPosts.data[0]){
			return
		}

		let post = catPosts.data[0][0];

		return <CategoryContent onClick={() => this._getPostsByTermIdData(term)} id={post.id} title={term.name} image={post.thumbnail_images.thumb_3_2_small.url} key={post.id}/>

	}

	_getPostsByTermIdData(term) {
		// let id = 1011;
		let encodedURI = encodeURI(
			'http://'+ this.state.hostUrl +'/api/core/get_posts_by_catID/?post_type=references&taxonomy=references_category&term_id='+ term.term_id +'&posts_per_page=-1'
		);

		return axios.get(encodedURI,{'content-type': 'application/json; charset=utf-8'})
			.then(
				(response) => {
					let catPosts = [];

					response.data[0].forEach((dat) => {
						catPosts = catPosts.concat(dat);
					});

					let termDesc = null;

					this.setState({
						categorieVypis: {
							disable: true
						}
					});

					if(this.state.categorieVypis.disable){
						termDesc = term.description;
					}

					this.setState({
						categoryItems: {
							data: catPosts,
							catDesc: termDesc
						},
						postData: null
					});



				}
			)
			.catch(err => console.log(err));
	}

	_getPostData(id) {
		// let id = 1011;
		let encodedURI = encodeURI(
			'http://'+ this.state.hostUrl +'/api/get_cur_post/?id='+ id +'&post_type=references'
		);

		return axios.get(encodedURI)
			.then(
				(response) => {

					this.setState({
						postData: response.data
					});
				}
			)
			.catch(err => console.log(err));

	}

	_changePostVisibility() {
		this.setState({
			postData: null
		});
	}

	_getPost() {
		if(!this.state.postData){
			return
		}
		return <PostContent onClick={() => this._changePostVisibility()} postData={this.state.postData} data-post-id={this.state.postData.id} key={this.state.postData.id}/>
	}

	_getCategoryPosts() {
		// Set categories items by term_id
		if(!this.state.categoryItems.data){
			return
		}
		return (this.state.categoryItems.data).map((post) => {

			return <CategoryContent onClick={() => this._getPostData(post.id)} id={post.id} title={post.title} image={post.thumbnail_images.thumb_3_2_small.url} key={post.id}/>
		})
	}

	_getCategoriesMenu(catArr) {
		if (!catArr) {
			return
		}
		return catArr.map((key, index) => {
			return <CategoryItem onClick={() => this._getPostsByTermIdData(key)} catId={key.term_id} key={index} value={key.name}/>
		});
	}

	_getTaxonomiesData() {
		let taxonomySlug = 'references_category';

		let encodedURI = encodeURI(
			'http://'+ this.state.hostUrl +'/api/taxonomy/get_terms/?taxonomy=' + taxonomySlug + '/'
		);

		return axios.get(encodedURI)
			.then(
				(response) => {
					return response.data;
				}
			)
			.catch(err => console.log(err))
	}


	_getMainCatShows(){
		if(this.state.categorieVypis.disable){
			return
		}

		if(!this.state.categorieVypis.rendered){

			let catPromiseData = [];

			if(this.state.categoryData){
				(this.state.categoryData).forEach((item) => {
					catPromiseData = catPromiseData.concat(this._getOncePostFromTermByTermIdData(item));
					return item;
				});

				Promise.all(catPromiseData)
					.then(data => {

						// data.map( (item) => {
						// 	console.log(item);
						// });
						this.setState({
							categorieVypis: {
								data: data,
								rendered: true
							}
						});
					});
			}
		}
		return this.state.categorieVypis.data;
	}

	componentDidMount() {
		this._getTaxonomiesData().then( (results) => {
			this.setState({
				categoryData: results.terms
			});
		});
		// this._getPost();
	};


	render() {

		let mainCat = this._getMainCatShows();

		let catItems = this._getCategoryPosts();

		let currentPost = this._getPost();

		let spinner;
		if(!this.state.categorieVypis.rendered){
			spinner = " load-spinner";
		}else{
			spinner = "";
		}

		if (!this.state.categoryItems.data && !this.state.categorieVypis.rendered){
			spinner = " load-spinner";
		}else{
			spinner = "";
		}


		return (
			<div className="App">

				<div className="category-top-section">

					<div className="col-sm-12">

						<ul className="categories-tabs">
							{this._getCategoriesMenu(this.state.categoryData)}
						</ul>

						<div className="category-desc">
							<p>
								{this.state.categoryItems.catDesc}
							</p>
						</div>

					</div>

				</div>

				{currentPost}

				<div className={"categories-tiles" + spinner}>
					<div className="col-sm-12">
						<ul className="grid">

							{mainCat}

							{catItems}

						</ul>
					</div>
				</div>

			</div>
		);

	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js